import { FC } from "react";
import LogoImages from "../../assets/images/logoSvg.svg";
import LogoBangbow from "../../assets/images/logoBangbow.png";
import MobileOTPInput from "components/MobileOtpInput";
import styled from "@emotion/styled";
import { Col } from "antd";

const ConfirmOtpPage: FC = () => {
  return (
    <>
      <MainSection>
        <Col
          sm={{ span: 24, offset: 0 }}
          md={{ span: 12, offset: 6 }}
          lg={{ span: 6, offset: 9 }}
        ></Col>
        <ImageSection>
          <img
            src={LogoBangbow}
            alt="Logo"
            width={100}
            height={100}
            loading="lazy"
          />
        </ImageSection>
        <SectionInput>
          <MobileOTPInput />
        </SectionInput>
      </MainSection>
    </>
  );
};

export default ConfirmOtpPage;

const MainSection = styled.div`
  width: 100%;
  position: relative;
  min-height: 100vh;
  background-color: #fff;
`;


const ImageSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
  margin-bottom: 10px;
`;

const SectionInput = styled.div`
  padding: 0 20px;
`;


